import App from "@app/components/portfolio/app";

import "@app/style/index.scss";

export default App;
